import * as React from "react";
import { Link } from "gatsby";
import Seo from "../components/seo";
import { Container, Row, Col, Tab, Nav, Image, Card, Accordion } from "react-bootstrap";
import { SoftwareDevelopmentCompanyMeta } from "../data/metaData";
import Layout from "../components/layout/layout";
import { StaticImage } from "gatsby-plugin-image";
import LazyLoad from "react-lazy-load";


import ReactJS from "../images/technologies/react.svg";
import Angular from "../images/technologies/angular.svg";
import Vue from "../images/technologies/vue.svg";
import JavaScript from "../images/technologies/javascript.svg";
import Java from "../images/technologies/java.svg";
import NET from "../images/technologies/dotnet.svg";
import Python from "../images/technologies/python.svg";
import NodeJS from "../images/technologies/node.svg";
import Android from "../images/technologies/android.svg";
import iOS from "../images/technologies/ios.svg";
import Flutter from "../images/technologies/flutter.svg";
import AWS from "../images/technologies/aws.svg";
import Azure from "../images/technologies/azure.svg";
import GCP from "../images/technologies/gcp.svg";
import BackboneJS from "../images/technologies/backbone.svg";
import HTML from "../images/technologies/html.svg";
import TypeScript from "../images/technologies/typescript.svg";
import Ember from "../images/technologies/ember.svg";
import Bootstrap from "../images/technologies/bootstrap.svg";
import CSS from "../images/technologies/css.svg";
import Laravel from "../images/technologies/laravel.svg";
import Golang from "../images/technologies/golang.svg";
import PHP from "../images/technologies/php.svg";
import Meteor from "../images/technologies/meteor.svg";
import Express from "../images/technologies/express.svg";
import Firebase from "../images/technologies/firebase.svg";
import PostgreSQL from "../images/technologies/postgre-sql.svg";
import MySQL from "../images/technologies/mysql.svg";
import DynamoDB from "../images/technologies/dynamodb.svg";
import Redis from "../images/technologies/redis.svg";
import MongoDB from "../images/technologies/mongodb.svg";
import Oracle from "../images/technologies/oracle.svg";
import SQLite from "../images/technologies/sqlite.svg";

import videoName from "../images/video/software-development-company-movie.webm";

import { Animations } from "../components/animations";
import Icon1 from "../animations/web-application-development/experience_developer.json";
import Icon2 from "../animations/web-application-development/cutting_edge_technology.json";
import Icon3 from "../animations/mobile-application-development/Transparency-Communication.json";
import Icon4 from "../animations/web-application-development/on_time_delivery.json";
import Icon5 from "../animations/web-application-development/high_quality_solution.json";
import Icon6 from "../animations/web-application-development/customer_experience.json";
// import Faqs from "../components/faqs";

const ClientsTestimonial = React.lazy(() => import('../components/clients-testimonial'))
const BlogList = React.lazy(() => import('../components/blog/blog-list'))
const CaseStudy = React.lazy(() => import('../components/case-study'))
const WhyChooseFacts = React.lazy(() => import('../components/why-choose-facts'))
const Advantage = React.lazy(() => import('../components/advantage'))
const Faqs = React.lazy(() => import('../components/faqs'))
const OurClientsSingleLine = React.lazy(() => import("../components/our-clients-single-line"));

export const Head = () => (
  <Seo
    title={SoftwareDevelopmentCompanyMeta.metaTitle}
    description={SoftwareDevelopmentCompanyMeta.metaDescription}
    ogImage={SoftwareDevelopmentCompanyMeta.ogImage}
    twitterImage={SoftwareDevelopmentCompanyMeta.twitterImage}
  />
)

const SoftwareDevelopmentCompanyPage = () => {

  const CTABgDark = '../images/cta-bg-dark1.png'
  const Softwaredevelopmentcompanyprocess = '../images/software-development-company-process.png'
  const improvingdata = [
    {
      title: "Custom software development",
      des: "Our custom software development services are designed to align precisely with your business objectives. We focus on delivering quality solutions that enhance operational efficiency and drive measurable growth from initial concept to successful deployment."
    },
    {
      title: "Software product development",
      des: "Our software product development services are aimed at turning your ideas into market-ready digital solutions. We partner with you at every step, ensuring your vision is translated through innovative design and effective implementation, leading to a successful launch."
    },
    {
      title: "Enterprise software development",
      des: "Our enterprise software development services are customized to meet the unique demands of large organizations. We develop scalable, robust solutions that not only streamline operations but also empower your business to adapt and grow in an ever-changing digital realm."
    },
    {
      title: "Software consulting services",
      des: "Our software consulting services provide strategic insights and expert guidance to help you navigate complex challenges. We collaborate closely with you to develop tailored solutions that align with your business goals, ensuring you maximize your investment and achieve desired outcomes."
    },
    {
      title: "Web development",
      des: "Our <a href='/web-application-development.html' class='text-primary'>web development services</a> focus on creating high-performance web applications that drive user engagement. With expertise in building 300+ web apps, Peerbits professionally designs, redesigns, and builds industry-leading web-based products that help you achieve higher conversion rates.",
      // linktext: "Learn More",
      // url: "/web-application-development.html"
    },
    {
      title: "MVP development",
      des: "Our <a href='/mvp-development-company.html' class='text-primary'>MVP development</a> services rapidly validate your concept with real users. We help you build a basic version of your app with core features and determine the long-term roadmap while accelerating time to market and minimizing development costs.",
      // linktext: "Learn More",
      // url: "/mvp-development-company.html"
    },
    {
      title: "SaaS development",
      des: "Our <a href='/saas-development-company.html' class='text-primary'>SaaS development services</a> are dedicated to creating flexible, secure, and scalable solutions that enhance user experience and support your business growth. We ensure that your cloud applications are not only robust but also adaptable to evolving market demands, empowering your organization to thrive.",
      // linktext: "Learn More",
      // url: "/saas-development-company.html"
    },

    {
      title: "API development",
      des: "We create secure and efficient APIs that enable seamless communication between applications. Our developers ensure your APIs are robust, making integrations easy and reliable. This helps you enhance functionality and improve user experiences.",
      // url: "/saas-development-company.html"
    },
    {
      title: "Custom CRM development",
      des: "Our custom CRM solutions are designed to meet your unique business needs. We streamline processes, improve customer relationships, and boost productivity with custom features. This empowers your software development team to work smarter and drive growth.",
      // linktext: "Learn More",
      // url: "/saas-development-company.html"
    },
    {
      title: "Software integration services",
      des: "We specialize in integrating various software systems to improve efficiency and data flow. Our team ensures your tools work together seamlessly, reducing manual effort and errors. This integration helps you save time and make informed decisions.",
      // linktext: "Learn More",
      // url: "/saas-development-company.html"
    },
  ]

  const tabcontent = [
    {
      title: "Frontend",
      list: [
        {
          link: "/reactjs-development.html",
          img: ReactJS,
          width: 58,
          height: 52,
          name: "React JS"
        },
        {
          link: "/angularjs-development.html",
          img: Angular,
          width: 53,
          height: 56,
          name: "Angular"
        },
        {
          link: "/vuejs-development.html",
          img: Vue,
          width: 56,
          height: 50,
          name: "Vue JS"
        },
        {
          img: JavaScript,
          width: 56,
          height: 56,
          name: "JavaScript"
        },
        {
          img: TypeScript,
          width: 56,
          height: 56,
          name: "TypeScript"
        },
        {
          img: BackboneJS,
          width: 46,
          height: 56,
          name: "Backbone JS"
        },
        {
          img: Ember,
          width: 117,
          height: 48,
          name: "Ember JS"
        },
        {
          img: Bootstrap,
          width: 56,
          height: 45,
          name: "Bootstrap"
        },
        {
          img: HTML,
          width: 56,
          height: 56,
          name: "HTML5"
        },
        {
          img: CSS,
          width: 56,
          height: 56,
          name: "CSS3"
        }
      ]
    },
    {
      title: "Backend",
      list: [
        {
          link: "/java-development.html",
          img: Java,
          width: 42,
          height: 56,
          name: "Java"
        },
        {
          link: "/dot-net-development-company.html",
          img: NET,
          width: 106,
          height: 42,
          name: ".NET"
        },
        {
          link: "/python-development.html",
          img: Python,
          width: 56,
          height: 56,
          name: "Python"
        },
        {
          link: "/nodejs-development.html",
          img: NodeJS,
          width: 72,
          height: 44,
          name: "Node JS"
        },
        {
          link: "/laravel-development.html",
          img: Laravel,
          width: 55,
          height: 56,
          name: "Laravel"
        },
        {
          img: Golang,
          width: 108,
          height: 40,
          name: "Golang"
        },
        {
          img: Meteor,
          width: 56,
          height: 55,
          name: "Meteor JS"
        },
        {
          img: Express,
          width: 79,
          height: 42,
          name: "Express JS"
        },
        {
          link: "/php-web-development.html",
          img: PHP,
          width: 93,
          height: 50,
          name: "PHP"
        }
      ]
    },
    {
      title: "Database",
      list: [
        {
          img: Firebase,
          width: 41,
          height: 56,
          name: "Firebase"
        },
        {
          img: Redis,
          width: 61,
          height: 52,
          name: "Redis"
        },
        {
          img: PostgreSQL,
          width: 54,
          height: 56,
          name: "PostgreSQL"
        },
        {
          img: MongoDB,
          width: 58,
          height: 58,
          name: "MongoDB"
        },
        {
          img: MySQL,
          width: 85,
          height: 44,
          name: "MySQL"
        },
        {
          img: DynamoDB,
          width: 48,
          height: 54,
          name: "DynamoDB"
        },
        {
          img: Oracle,
          width: 128,
          height: 17,
          name: "Oracle"
        },
        {
          img: SQLite,
          width: 51,
          height: 56,
          name: "SQLite"
        }
      ]
    },
    {
      title: "Mobile",
      list: [
        {
          link: "/android-application-development.html",
          img: Android,
          width: 48,
          height: 58,
          name: "Android"
        },
        {
          link: "/ios-application-development.html",
          img: iOS,
          width: 45,
          height: 52,
          name: "iOS"
        },
        {
          link: "/react-native-app-development.html",
          img: ReactJS,
          width: 58,
          height: 52,
          name: "React Native"
        },
        {
          link: "/flutter-app-development.html",
          img: Flutter,
          width: 45,
          height: 56,
          name: "Flutter"
        }
      ]
    },
    {
      title: "Cloud",
      list: [
        {
          img: AWS,
          width: 60,
          height: 60,
          name: "AWS"
        },
        {
          img: Azure,
          width: 60,
          height: 60,
          name: "Azure"
        },
        {
          img: GCP,
          width: 60,
          height: 60,
          name: "GCP"
        }]
    }
  ]
  const choosedata = [
    {
      icon: Icon1,
      title: "Experienced team",
      des: "Being backed up by a team of expert software developers, we have a successful track record of providing efficient and effective solutions matching your exact business requirements."
    },
    {
      icon: Icon2,
      title: "Technological competitive edge",
      des: "Our company is proficient in the latest technology stack to help clients get future-ready software development solutions that meet their business objectives effectively."
    },
    {
      icon: Icon3,
      title: "Effective communication",
      des: "We maintain complete transparency with our clients. Along with that we also keep the clients informed about any latest updates that can benefit their project."
    },
    {
      icon: Icon4,
      title: "Reduced time to market",
      des: "When you hire us as your software development service partner, you can be assured to receive fast & efficient solutions that empower you to reach the target audience quickly."
    },
    {
      icon: Icon5,
      title: "Top-quality software",
      des: "Our commitment to excellence & <a href='/blog/importance-of-code-quality-in-custom-software-development.html' class='text-primary'>code quality</a> enables us to deliver the best software development services in  US & India delivering complete client satisfaction for all projects."
    },
    {
      icon: Icon6,
      title: "Best value for money",
      des: "At Peerbits, we make sure that our clients achieve maximum ROI on their software development projects. We walk the extra mile to deliver the best solutions for our clients worldwide."
    },
  ]

  const service = [
    {
      title: "Healthcare",
      iconclass: "healthcare",
      des: "Healthcare SaaS platform, Telemedicine app, mHealth apps, & other healthcare software development solutions ",
      secdes: "Peerbit’s software developer’s experience in healthcare designs software solutions that adhere to necessary compliance regulations, with the goal of enhancing patient outcomes, facilitating remote care, and streamlining medical workflows through automation.",
      linkname: "Explore our healthcare expertise",
      url: "/healthcare-software-development.html"

    },
    {
      title: "Finance",
      iconclass: "finance",
      des: "Fintech SaaS platforms, Mobile wallet apps, Neobank apps, & other financial software development solutions.",
      secdes: "We combine our technical skills with knowledge of finance to develop a diverse FinTech solution that enhances the transactional process, following necessary security compliances-leading to a significant increase in market share.",
      linkname: "Transform your finances",
      url: "/financial-software-development.html"
    },

    {
      title: "Logistics",
      iconclass: "logistics",
      des: "Logistics SaaS solutions, Route optimization software, Freight management apps, & other logistics software development solutions.",
      secdes: "Our industry experience in logistics software development enables us to build a scalable system & secure transportation operations for evolving needs. We ensure to improve the overall profitability of your logistics business.",
      linkname: "Optimize your logistics",
      url: "/logistics-software-development.html"

    },
    {
      title: "Retail",
      iconclass: "retail",
      des: "Retail SaaS platforms, E-commerce solutions, Inventory management systems, & other retail software development solutions.",
      secdes: "We specialize in creating dynamic solutions that elevate the customer experience, optimize inventory management, and integrate e-commerce functionalities supporting you in boosting sales and expanding your market presence.",
      linkname: "Boost your retail performance",
      url: "/retail-mobility-solutions.html"

    },
    {
      title: "Manufacturing",
      iconclass: "manufacturing",
      des: "Manufacturing SaaS solutions, Supply chain management software, IoT-enabled production apps, & other manufacturing software development solutions.",
      secdes: "Our team of software developers delivers innovative solutions for the manufacturing industry that optimize their production efficiency, streamline supply chain management, and use IoT technology to enhance operational workflows. ",


    },
    {
      title: "Automotive",
      iconclass: "automative",
      des: "Automotive SaaS solutions, Fleet management software, Vehicle telematics apps, & other automotive software development solutions.",
      secdes: "Our automotive software development experts design integrated solutions that enhance fleet efficiency, provide real-time vehicle insights through telematics, and improve overall operational workflows, positioning your business for ultimate growth.",

    },
  ]

  const accordian = [
    {
      title: "How do you ensure the quality of the software being developed?",
      des: "Quality assurance is an integral factor of our development process. We conduct rigorous testing at each stage of development, implement best coding practices, and perform code reviews to ensure <a href='/blog/quality-assurance-process-peerbits.html' class='text-primary'> quality assurance</a> at every stage."
    },
    {
      title: "How do you handle project timelines and deadlines?",
      des: "We create detailed project plans with clear timelines and milestones. Regular progress updates and proactive communication help us adhere to deadlines effectively."
    },
    {
      title: "What communication channels do you use during the project?",
      des: "We utilize a range of communication tools including email, video calls, project management platforms, and regular status meetings to ensure smooth and transparent communication."
    },
    {
      title: "How do you determine the cost of a software project?",
      des: "Project costs are estimated based on factors like project scope, complexity, required technologies, and anticipated hours of work. We ensure to send transparent pricing breakdowns before project commencement."
    },
    {
      title: "Can you provide a breakdown of the pricing structure?",
      des: "Certainly, once your planning & project requirements are finalized, we'll provide a detailed breakdown of all costs, including development, testing, support, and any other associated expenses."
    },
    {
      title: "How do I get top software development outsourcing services?",
      des: "You can directly reach out to us with your project details, vision, and requirements for developers or teams. Once discussing your needs, our experts will guide you through the process. For more information, you can explore our <a href='/engagement-model.html' class='text-primary'>engagement models</a> for further hiring."
    },
    {
      title: "How long does it take to process my request and start working together?",
      des: "We typically review your initial request within 1-2 business days. After that, we’ll schedule a meeting to discuss the next steps for collaboration."
    },
    {
      title: "Can you integrate my custom solution with existing systems or third-party tools?",
      des: "Yes, we can seamlessly integrate your custom solution with your existing software and third-party tools. Our integrations ensure smooth data exchange and enhance functionality across platforms."
    },
    {
      title: "Do you offer post-development maintenance services of the software application?",
      des: "We are a full-service bespoke software development firm that offers services such as design, development, implementation, and application maintenance. Software support is just as vital as designing it since it keeps it alive and relevant. As a business software development company, we ensure feature upgrades, optimization, QA Testing, and preventative maintenance as part of our post-maintenance services"
    }
  ]
  return (
    <>
      <Layout headerClass="navbar-dark">
        <section className="section section-background video-banner bg-black min-vh-100 d-flex align-items-center flex-column pb-0">
          <div className="my-auto">
            <Container className="py-5 mt-lg-5">
              <div className="max-width-950 text-center mx-auto">
                <h1 className="sub-title mb-3 text-white-75">SOFTWARE DEVELOPMENT SERVICES</h1>
                <h2 className="mb-4 h1 text-white">
                  Building <span className="text-primary">tomorrow’s</span> software today
                </h2>
                <p className="text-white-75 lead">
                  We deliver robust and scalable software development solutions to automate your business operations, reduce human errors, and lower costs. Our software developers build unique solutions to help you outperform your competitors.
                </p>
                <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme-outline mt-4">
                  Discuss your project
                </Link>
              </div>
            </Container>
          </div>
          <LazyLoad>
            <div className="section-background-image">
              <video playsInline loop={true} autoPlay={true} muted width="100%" height="100%" controls={false}>
                <track kind="captions" srcLang="en" label="English" />
                <source src={videoName} type="video/webm"></source>
              </video>
            </div>
          </LazyLoad>
          <div className='py-4 bg-black w-100'>
            <LazyLoad>
              <OurClientsSingleLine />
            </LazyLoad>
          </div>
        </section>

        <Advantage />

        <section className="section bg-light">
          <Container className="py-5">
            <Row className="g-5">
              <Col lg={6}>
                <div className="sticky-section">
                  <h2 className="sub-title mb-3">CUSTOM SOFTWARE DEVELOPMENT SERVICES</h2>
                  <h3 className="mb-4 h2">
                    <span className="text-primary">Improving</span> business agility
                  </h3>
                  <p className="lead">We help businesses automate, streamline, and simplify their processes with our reliable software development services. Whether you want to launch new products, add new features or modernize existing legacy systems, our company helps you excel at every challenge. Drive growth with our offshore software development services and develop reliable & scalable software solutions for any OS, device, or browser. </p>
                  <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme-outline mt-3">
                    Talk to our team
                  </Link>
                </div>
              </Col>
              <Col lg={6}>
                <Row className="g-4" xs={1} md={1} lg={1}>
                  {
                    improvingdata.map((item, index) => (
                      <Col key={index}>
                        <div className="dark-box-2 border">
                          <p className="text-primary mb-3">
                            <i className="zmdi zmdi-dot-circle zmdi-hc-fw font-size-24"></i>
                          </p>
                          <h3 className="h4 mb-3">{item.title}</h3>
                          <p className="mb-0" dangerouslySetInnerHTML={{ __html: item.des }}></p>
                          {
                            item.linktext ?
                              <Link to={item.url} className="btn btn-link px-0 mt-3">
                                <span>Learn More</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                              </Link> :
                              null
                          }
                        </div>
                      </Col>
                    ))
                  }

                </Row>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="section">
          <Container className="py-5">
            <div className="mb-5 pb-1">
              <h2 className="mb-4">
                Our <span className="text-primary">technical expertise</span> to build advanced software
              </h2>
              <p className="max-width-950 lead"> We build powerful software with <a href='/technology-stack.html' className='text-primary'>top technologies</a> to automate your businesses. Our software development team is skilled in utilizing latest programming languages, powerful frameworks, and efficient databases, to deliver impactful applications meeting client’s specific needs.</p>
            </div>
            <div className="d-none d-md-block">
              <Tab.Container id="left-tabs-example" defaultActiveKey="0">
                <Nav variant="pills" className="technologies-custom-tab mb-5 d-flex">
                  {
                    tabcontent.map((item, index) => (
                      <Nav.Item key={index}>
                        <Nav.Link eventKey={index}>{item.title}</Nav.Link>
                      </Nav.Item>
                    ))
                  }
                </Nav>
                <Tab.Content className="tab-content">
                  {
                    tabcontent.map((item, index) => (
                      <Tab.Pane eventKey={index} key={index}>
                        <Row className="g-4 justify-content-center technologies-icon-box" xs={1} md={3} sm={2} lg={6}>
                          {
                            item?.list?.map((item, index) => (
                              <Col key={index} >
                                {
                                  item.link ?
                                    <Link to={item.link} className="card equal-height">
                                      <Card.Body className="text-center p-4">
                                        <div className="icon mb-4">
                                          <Image loading="lazy" className="lazyload" src={item.img} width={item.width} height={item.height} alt="TechnologiesIcon" />
                                        </div>
                                        <h3 className="font-size-16 mb-0">
                                          {item.name}
                                        </h3>
                                      </Card.Body>
                                    </Link> :
                                    <div className="card equal-height">
                                      <Card.Body className="text-center p-4">
                                        <div className="icon mb-4">
                                          <Image loading="lazy" className="lazyload" src={item.img} width={item.width} height={item.height} alt="TechnologiesIcon" />
                                        </div>
                                        <h3 className="font-size-16 mb-0">
                                          {item.name}
                                        </h3>
                                      </Card.Body>
                                    </div>
                                }
                              </Col>
                            ))
                          }
                        </Row>
                      </Tab.Pane>
                    ))
                  }
                </Tab.Content>
              </Tab.Container>
            </div>
            <div className="d-block d-md-none tab-accordian">
              <Accordion defaultActiveKey="0" className="accordion-dark-box" flush>
                {tabcontent.map((item, index) => (
                  <Accordion.Item key={index} eventKey={index}>
                    <Accordion.Header><h3 className="h4 mb-0">{item.title}</h3></Accordion.Header>
                    <Accordion.Body>
                      <Row className="g-4 justify-content-center technologies-icon-box" xs={1} md={3} sm={2} lg={6}>
                        {
                          item?.list?.map((item, index) => (
                            <Col key={index} >
                              {
                                item.link ?
                                  <Link to={item.link} className="card equal-height">
                                    <Card.Body className="text-center p-4">
                                      <div className="icon mb-4">
                                        <Image loading="lazy" className="lazyload" src={item.img} width={item.width} height={item.height} alt="TechnologiesIcon" />
                                      </div>
                                      <h3 className="font-size-16 mb-0">
                                        {item.name}
                                      </h3>
                                    </Card.Body>
                                  </Link> :
                                  <div className="card equal-height">
                                    <Card.Body className="text-center p-4">
                                      <div className="icon mb-4">
                                        <Image loading="lazy" className="lazyload" src={item.img} width={item.width} height={item.height} alt="TechnologiesIcon" />
                                      </div>
                                      <h3 className="font-size-16 mb-0">
                                        {item.name}
                                      </h3>
                                    </Card.Body>
                                  </div>
                              }
                            </Col>
                          ))
                        }
                      </Row>
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
          </Container>
        </section>

        <section className="section bg-black">
          <Container className="pt-5">
            <div className="mb-5 pb-1">
              <h2 className="mb-4 text-white">
                How we make your business a <span className="text-primary">legendary</span>
              </h2>
              <p className="max-width-950 lead text-white-75">Peerbits delivers high-quality products through a systematic approach, ensuring projects are completed on time and meet your expectations. We follow the best practices and development methodologies for building effective enterprise software solutions of various complexity and sizes. Here’s a peek at our winning development process.</p>
            </div>
          </Container>
          <Container fluid className="pb-5 text-center">
            <LazyLoad><StaticImage loading="lazy" src={Softwaredevelopmentcompanyprocess} alt="Softwaredevelopmentcompanyprocess" width={1292} height={466} /></LazyLoad>
          </Container>
        </section>

        <CaseStudy
          title="Transforming ideas into <span class='text-primary'>success</span>: Next can be yours!"
          description='Discover a selection of our most impactful software projects, where innovation meets functionality. Each case study highlights our approach, challenges faced, and the successful outcomes achieved for our clients.'
          sectionClass="bg-light"
          category='Software'
        />

        <section className="section ">
          <Container className="py-5">
            <div className="mb-5 pb-1">
              <h2 className="mb-4">
                Why partner with us:<br /> Your <span className="text-primary">trusted development</span> ally
              </h2>
              <p className="max-width-950 lead"> Explore the key advantages of choosing us for your software development projects. As a leading <a href='/' className='text-primary'>custom software development company in India</a>, we have a proven track record, a talented team, and a focus on collaboration, to deliver solutions that exceed expectations.</p>
            </div>
            <WhyChooseFacts />
            <Row className="g-4 hover-box" xs={1} md={2} lg={3}>
              {
                choosedata.map((item, index) => (
                  <Col key={index}>
                    <div className="dark-box-2 center-icon-box equal-height">
                      <div className="icon icon-size-70 mb-4">
                        <LazyLoad offset={150}>
                          <Animations animation={item.icon} />
                        </LazyLoad>
                      </div>
                      <h3 className="h4 mb-3">{item.title}</h3>
                      <p className="" dangerouslySetInnerHTML={{ __html: item.des }} />
                    </div>
                  </Col>
                ))
              }
            </Row>
            <div className="pt-5 mt-4 text-center">
              <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme-outline">
                Build a successful software
              </Link>
            </div>
          </Container>
        </section>
        <section className="section bg-light">
          <Container className="py-5">
            <div className="mb-5 pb-1 max-width-950">
              <h2 className="mb-4">
                Innovative <span className="text-primary">software expertise</span> for every sector
              </h2>
              <p className="max-width-950 lead">Explore a wide range of industries we serve for various domains. With our commitment to excellence, we’ve established ourselves as the leading digital transformation partner solving unique challenges and meeting the requirements of each sector with our innovative custom software solutions.</p>
            </div>
            <Row as="ul" xs={1} md={2} lg={3} className="list-unstyled industries-flip-hover-box g-4">
              {
                service.map((item, index) => (
                  <Col as="li" key={index}>
                    {
                      item.url ?
                        <Link to={item.url} className="flip-card dark-box-2 p-0 rounded-3 equal-height">
                          <div className="flip-card-inner">
                            <div className="flip-card-front p-4">
                              <i className={`mobile-application-sprite-icon ${item.iconclass} icon-size-70 mb-3`}></i>
                              <h3 className="h4 mb-3">{item.title}</h3>
                              <p className="text mb-0">{item.des}</p>
                            </div>
                            <div className="flip-card-back p-4">
                              <h3 className="h4 mb-3">{item.title}</h3>
                              <p>{item.secdes}</p>
                              <span className="btn btn-link px-0">
                                <span>{item.linkname}  </span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                              </span>
                            </div>
                          </div>
                        </Link> :

                        <div className="flip-card dark-box-2 p-0 rounded-3 equal-height">
                          <div className="flip-card-inner">
                            <div className="flip-card-front p-4">
                              <i className={`mobile-application-sprite-icon ${item.iconclass} icon-size-70 mb-3`}></i>
                              <h3 className="h4 mb-3">{item.title}</h3>
                              <p className="text mb-0">{item.des}</p>
                            </div>
                            <div className="flip-card-back p-4">
                              <h3 className="h4 mb-3">{item.title}</h3>
                              <p className="mb-0">{item.secdes}</p>
                              {/* <span className="btn btn-link px-0">
                                <span>{item.linkname}  </span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                              </span> */}
                            </div>
                          </div>
                        </div>
                    }
                  </Col>
                ))
              }
            </Row>
          </Container>
        </section>

        <ClientsTestimonial
          title="<span class='text-primary'>Client</span> feedback: Real results, roaring impact"
          description="Discover testimonials from our satisfied clients who have experienced the transformative power of our software development services. Their success stories reflect our commitment to excellence and collaboration."
          sectionClass="bg-white"
        />

        <section className="section bg-black section-background">
          <Container className="py-5">
            <div className="text-center max-width-1000 mx-auto">
              <h2 className="heading mb-4 text-white">
                Looking for <span className="text-primary">software solutions</span> that fulfills your business goals?
              </h2>
              <p className="mb-5 text-white-75">Whether you're a startup or an established enterprise, we offer custom software development services designed to meet your specific requirements.</p>
              {/* <p className="lead fw-medium text-white-75">Contact us now and let's bring your vision to life.</p> */}
              <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme-outline mt-4">
                Let’s start today
              </Link>
            </div>
          </Container>
          <LazyLoad>
            <StaticImage
              style={{ position: 'absolute' }}
              className='section-background-image'
              loading='lazy'
              src={CTABgDark}
              alt='Home banner pattren'
            />
          </LazyLoad>
        </section>
        <Faqs accordian={accordian} />
        <BlogList
          category='Software Development'
          title="Insightful <span class='text-primary'>blogs</span>"
          description="Stay updated with the trend exploring our super insightful technical blogs."
        />
      </Layout >
    </>
  );
};

export default SoftwareDevelopmentCompanyPage;
